export  const ERROR_MSG = {
  'required': 'This field is required',
  'min-length': 'This field must contain at least',
  'max-length': 'This field must contain maximum'

}
